import {AppState} from "../store/configureStore";

export const CreateAuthHeader = (getState: () => AppState) => {
    return {headers: {Authorization: `Bearer ${getState().auth.activetoken}`}};
};